import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=2b58a6a8&scoped=true&"
var script = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=2b58a6a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58a6a8",
  null
  
)

export default component.exports